import { useEffect } from 'react';

export const useEmergencyExitHandler = (isActive, onExit) => {
    useEffect(() => {
        if (isActive) {
            const setupEmergencyExitEventListeners = () => {
                window.addEventListener('popstate', onExit);

                const originalPushState = history.pushState;

                history.pushState = (...args) => {
                    originalPushState?.apply(this, args);
                    onExit();
                };

                window.addEventListener('beforeunload', onExit);

                return () => {
                    window.removeEventListener('popstate', onExit);
                    history.pushState = originalPushState;

                    window.removeEventListener('beforeunload', onExit);
                };
            };

            const cleanup = setupEmergencyExitEventListeners();
            return cleanup;
        }
    }, [isActive, onExit]);
};
